import { Route, Routes } from "react-router-dom"
import { Catalog } from "../pages/main"
import { DetailCatalog } from "../pages/detail"
import { ServiceProvider } from "../context"



const CatalogRoute = () => {
  return (
    <ServiceProvider>
      <Routes>
        <Route path="/" element={<Catalog />} />
        <Route path="create" element={<DetailCatalog />} />
        <Route path="edit/:id" element={<DetailCatalog />} />
      </Routes>
    </ServiceProvider>
  )
}

export default CatalogRoute
